export default __webpack_public_path__ + "static/media/Green0002.881ab20d.png";